// https://fordprofile.cms.dealer.com/ford-blue-advantage-overview-atmbg.htm
// Ford Blue Advantage overview landing page tagging (US2013636 / DWPROJ-1002).
// Matches brochure download links by visible text so tagging survives PDF asset swaps.
export default {
	events: {
		'ddc.link.generic': [
			{
				// View EV Certified Brochure PDF download
				logic: ({ eventData }) =>
					eventData?.text === 'View EV Certified Brochure',
				payload: {
					directCall: 'global-download',
					payload: {
						onclick: {
							onclick:
								'used:si:cpo overview blue advantage:brochure download:ev certified',
							onclickLinkName:
								'{client}:used:si:cpo overview blue advantage:download'
						},
						page: {
							pageNameNoVehicle:
								'{client}:used:si:cpo overview blue advantage'
						},
						event: {
							action: 'pdf brochure|tool'
						}
					}
				}
			},
			{
				// 127-Point Inspection Checklist PDF download
				// NOTE: live page link text has no "View" prefix (unlike the brochure link);
				// verified against the synced NP render, not the spec doc heading.
				logic: ({ eventData }) =>
					eventData?.text === '127-Point Inspection Checklist',
				payload: {
					directCall: 'global-download',
					payload: {
						onclick: {
							onclick:
								'used:si:cpo overview blue advantage:brochure download:127 point checklist',
							onclickLinkName:
								'{client}:used:si:cpo overview blue advantage:download'
						},
						page: {
							pageNameNoVehicle:
								'{client}:used:si:cpo overview blue advantage'
						},
						event: {
							action: 'pdf brochure|tool'
						}
					}
				}
			}
		]
	}
};
